let inputs = document.querySelectorAll('.js-filter-input'),
    apply = document.querySelector('.js-apply-filters'),
    show = document.querySelectorAll('.js-show-filters'),
    showMobile = document.querySelectorAll('.js-show-filters--mobile'),
    filterElementsMobile = document.querySelectorAll('.filter-form__controls--mobile'),
    filters = document.querySelector('.js-filters'),
    filterBar = document.querySelector('.js-filter-bar'),
    filterGroups = document.querySelectorAll('.js-filter-group'),
    filterTabs = document.querySelectorAll('.js-filter-tab'),
    filterElements = [filters, filterBar];

inputs.forEach((input) => {
    input.addEventListener('change', () => {
        apply.classList.add('active');
    });
});

show.forEach((show) => {
  show.addEventListener('click', (event) => {
      show.classList.toggle('active');
      event.preventDefault();
      filters.classList.toggle('active');

  });
});


var config = {
    animation: {
        enable: false
    },
    selectors: {
        target: '.js-grid-item'
    },
    load: {
        sort: 'color'
    },
    multifilter: {
        enable: true // enable the multifilter extension for the mixer
    }
};

// Pass the configuration object to the mixitup factory function
const containerEl = document.querySelector('.js-grid');

// "No results" message, shown when a filter combination matches nothing.
// MixItUp v3 has no `templates.fail` config (sealed config throws), so we
// toggle our own element off the `mixEnd` event instead.
if (containerEl) {
    const failMessage = document.createElement('li');
    failMessage.className = 'grid__item grid__item--full-width js-filter-no-results';
    failMessage.setAttribute('aria-live', 'polite');
    failMessage.innerHTML = '<h4 class="headline">No products match your filters.</h4>';
    failMessage.hidden = true;
    containerEl.appendChild(failMessage);

    containerEl.addEventListener('mixEnd', (e) => {
        failMessage.hidden = e.detail.state.totalShow > 0;
    });

    var mixer = mixitup(containerEl, config);
}

// Defer rollover (hover) images: fetch them only when a card is hovered or
// focused, so the initial grid loads ~half as many images. Touch devices have
// no rollover, so they never download these images at all.
document.querySelectorAll('.js-hover-defer').forEach((img) => {
    const card = img.closest('.js-grid-item') || img;
    const load = () => {
        if (img.dataset.srcset) { img.srcset = img.dataset.srcset; }
        if (img.dataset.src) { img.src = img.dataset.src; }
        card.removeEventListener('mouseenter', load);
        card.removeEventListener('focusin', load);
    };
    card.addEventListener('mouseenter', load);
    card.addEventListener('focusin', load);
});
